import $ from 'jquery'

/*
  入力エラーの表示
  Figma: form/input・form/text・form/select の State=error / State=error:focus
  エラー時は入力欄に _error を付け、同じ階層の末尾に .p-jrc-form-error を挿入する
*/
var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function labelOf($field) {
  return $.trim(
    $field.closest('.p-jrc-form-field').find('.p-jrc-form-field__name').first().text()
  )
}

/* エラーテキストの挿入先。横並びの項目は列単位、同意チェックはその囲みに入れる */
function hostOf($field) {
  var $col = $field.closest('.p-jrc-form-field__col')
  if ($col.length) return $col

  var $control = $field.closest('.p-jrc-form-field__control')
  if ($control.length) return $control

  return $field.closest('.p-jrc-form-agreement')
}

function messageOf($field, $form) {
  var el = $field[0]

  if (el.type === 'checkbox') {
    return el.required && !el.checked ? '個人情報の取扱いに同意してください。' : ''
  }

  var value = $.trim(String($field.val() || ''))

  if (el.required && !value) {
    return labelOf($field) + (el.tagName === 'SELECT' ? 'を選択してください。' : 'を入力してください。')
  }
  if (!value) return ''

  if (el.type === 'email' && !EMAIL.test(value)) {
    return 'メールアドレスの形式が正しくありません。'
  }
  if (el.name === 'email_confirm') {
    var email = $.trim(String($form.find('[name="email"]').val() || ''))
    if (value !== email) return 'メールアドレスが一致しません。'
  }
  return ''
}

function render($field, message) {
  var $host = hostOf($field)
  var $error = $host.children('.p-jrc-form-error')

  if (!message) {
    $field.removeClass('_error').removeAttr('aria-invalid').removeAttr('aria-describedby')
    $error.remove()
    return
  }

  if (!$error.length) {
    var id = ($field.attr('id') || $field.attr('name')) + '-error'
    $error = $('<p class="p-jrc-form-error"></p>').attr('id', id)
    $host.append($error)
  }

  $error.text(message)
  $field.addClass('_error').attr({
    'aria-invalid': 'true',
    'aria-describedby': $error.attr('id'),
  })
}

var formValidate = {
  init: function () {
    var $form = $('.p-inquiry-form')
    if (!$form.length) return

    var $fields = $form.find(
      '.p-jrc-form-input, .p-jrc-form-textarea, .p-jrc-form-select, .p-jrc-form-choice__input[type="checkbox"]'
    )
    if (!$fields.length) return

    // ブラウザ標準の吹き出しを止め、デザイン通りのエラー表示に寄せる
    $form.attr('novalidate', 'novalidate')

    $fields.on('blur change', function () {
      var $field = $(this)
      render($field, messageOf($field, $form))

      // メールアドレスを直したら確認欄の不一致エラーも追従させる
      if (this.name === 'email') {
        var $confirm = $form.find('[name="email_confirm"]')
        if ($confirm.hasClass('_error')) {
          render($confirm, messageOf($confirm, $form))
        }
      }
    })

    $form.on('submit', function (e) {
      var $first = null

      $fields.each(function () {
        var $field = $(this)
        var message = messageOf($field, $form)
        render($field, message)
        if (message && !$first) $first = $field
      })

      if (!$first) return

      e.preventDefault()

      // 追従ヘッダーの下に隠れないよう、その高さ分を引いて止める
      var headroom = ($('.p-header__inner').outerHeight() || 0) + 24

      $('html, body').animate({ scrollTop: $first.offset().top - headroom }, 400, function () {
        $first.trigger('focus')
      })
    })

    $form.on('reset', function () {
      // リセットは値が消えた後に判定する必要がある
      setTimeout(function () {
        $fields.each(function () {
          render($(this), '')
        })
      }, 0)
    })
  },
}

export default formValidate
